/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable no-empty */
/* eslint-disable no-console */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import _ from 'lodash';
import loader from '../images/loading.gif';
import getStudentDetentions from '../services/getStudentDetentions';
import formatDate from '../services/formatDate';

export default class Detentions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detentionDetails: [],
      loading: true,
      error: '',
      c: 1,
    };
  }

  componentDidMount() {
    let detention = [];
    detention = JSON.parse(localStorage.getItem('totalDetentions'));
    if (detention === 0) {
      const a = document.getElementsByClassName('tardy-main-div');
      if (a && a.length) {
        const b = a[0];
        if (window.screen.availHeight - 183 < b.scrollHeight) {
          this.setState({ c: 1 });
        }
      }
    } else {
      setInterval(() => {
        const a = document.getElementsByClassName('tardy-main-div');
        if (a && a.length) {
          const b = a[0];
          if (window.screen.availHeight - 183 < b.scrollHeight) {
            this.setState({ c: 0 });
          }
        }
      }, 0);
    }

    const studentDetails = JSON.parse(localStorage.getItem('studentDetails'));
    if (studentDetails) {
      let data = [];
      data = JSON.parse(localStorage.getItem('detentionDetails'));
      if (data) {
        this.setState({ detentionDetails: data, loading: false });
      }

      getStudentDetentions(studentDetails.school_code,
        studentDetails.student_no,
        studentDetails.student_id)
        .then((res) => {
          if (res.data) {
            const updatedData = res.data.detentionDetails;
            const result = _.isEqual(updatedData, data);
            if (result === false) {
              //  // console.log('Updated Detention');
              this.setState({ detentionDetails: res.data.detentionDetails, loading: false });
              localStorage.setItem('detentionDetails', JSON.stringify(res.data.detentionDetails));
            }
            const date = new Date();
            const formattedDate = formatDate(date);
            const detentionTime = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} at ${formattedDate[0]}:${formattedDate[1]} ${(formattedDate[2]).split(' ')[1]}`;
            localStorage.setItem('detentionCacheTime', JSON.stringify(detentionTime));
          } else {
            this.setState({ detentionDetails: [], loading: false });
          }
        })
        .catch(() => {
          const res = JSON.parse(localStorage.getItem('detentionDetails'));
          const date = localStorage.getItem('detentionCacheTime') || JSON.stringify('25/03/2020 at 16:20');
          this.setState({ error: `You are offline. Last update for Pending Detentions was at ${date.split('"')[1]}`, loading: false, detentionDetails: res || [] });
          // setTimeout(() => this.setState({ error: '' }), 10000);
        });
    } else {
      const { history } = this.props;
      history.replace('/');
    }
  }

  render() {
    const {
      loading, error, detentionDetails, c,
    } = this.state;
    if (loading) {
      return <img src={loader} className="menu-loader" alt="Loading ..." />;
    }
    const details = [];
    detentionDetails.forEach((element) => {
      details.push({
        id: element.id,
        date: ((element.created).split('T'))[0],
        time: ((((element.created).split('T'))[1]).split('+'))[0],
        assignedBy: element.referral,
        location: element.detention_location,
        minutes: element.minutes,
        status: element.status,
        type: element.detention_type,
      });
    });
    const detailsView = [];
    details.forEach((element) => {
      detailsView.push(
        <div className="tardy-list" key={element.id}>
          <div className="det-tardi">
            <p>
              <span>Date :</span>
              {' '}
              {element.date}
              {' '}
              <span>Time :</span>
              {' '}
              {element.time}
            </p>
            <p>
              <span>Assigned By :</span>
              {' '}
              {element.assignedBy}
            </p>
            <p>
              <span>Location :</span>
              {' '}
              {element.location}
            </p>
            <p>
              <span>Minutes :</span>
              {' '}
              {element.minutes}
            </p>
            <p>
              <span>Status :</span>
              {' '}
              {element.status}
            </p>
            <p>
              <span>Type :</span>
              {' '}
              {element.type}
            </p>
          </div>
        </div>,
      );
    });
    detailsView.reverse();
    return (
      <div>
        <div className="tardy-header">
          <p>Pending Detentions</p>
          <div
            className="home-btn"
            onClick={() => {
              const { history } = this.props;
              history.replace('/studentDetails');
            }}
            role="button"
            tabIndex={0}
            onKeyPress={() => {}}
          >
            <span><i className="fa fa-home" aria-hidden="true" /></span>
          </div>
        </div>
        {error && (
        <div className="offline-banner-tardy">
          {error}
        </div>
        )}
        <div className="tardy-list-wrapper" style={{ padding: 5, marginTop: 65, paddingBottom: 80 }}>
          <div className="tardy-main-div">
            {detailsView.length ? detailsView : <p className="no-data">Nothing to show here!</p>}
          </div>
        </div>
        <div
          className={c === 1 ? 'back-btn non-float' : 'back-btn'}
          style={c === 1 ? { left: (window.screen.width * 0.27) } : null}
          onClick={() => {
            const { history } = this.props;
            history.replace('/studentSchedule');
          }}
          role="button"
        >
          <p> &lt; Back</p>
        </div>
      </div>
    );
  }
}
